import { lazy } from "react";
import routes from "./routesConfig/index";

const ReportsPage = lazy(() => import("../reports/ReportsPage"));
const jobOfferReportPage = lazy(() => import("../reports/job-offer-report/JobOfferReportPage"));
const FeedbackReport = lazy(() => import("../reports/feedback-report/FeedbackReportPage"));
const InterviewReport = lazy(() => import("../reports/interview-report/InterviewReportPage"));
const InsuranceReport = lazy(() => import("../reports/insurance-report/InsuranceReportPage"));
const ContractReport = lazy(() => import("../reports/contract-report/ContractReportPage"));
const SessionHistoryReport = lazy(() => import("../reports/session-history-report/SessionHistoryReportPage"));
const ScheduleComplianceReport = lazy(() => import("../reports/schedule-compliance-report/ScheduleComplianceReportPage"));
const TimeRequestReport = lazy(() => import("../reports/time-request-report/TimeRequestReportPage"));
const LeaveHistoryReport = lazy(() => import("../reports/leave-history-report/LeaveHistoryReportPage"));
const TimeEntryReport = lazy(() => import("../reports/time-entry-report/TimerEntryReportPage"));

const reportRoutes = [
    { path: routes.reports, component: ReportsPage, moduleKey: "reports", permissionKey: "report_access"  },
    { path: routes.jobOfferReport, component: jobOfferReportPage,  moduleKey: "reports", permissionKey: "jo_report"  },
    { path: routes.feedbackReport, component: FeedbackReport,  moduleKey: "reports", permissionKey: "feedback_report"  },
    { path: routes.interviewReport, component: InterviewReport,  moduleKey: "reports", permissionKey: "interview_report"  },
    { path: routes.insuranceReport, component: InsuranceReport, moduleKey: "reports", permissionKey: "insurance_report" },
    { path: routes.contractReport, component: ContractReport, moduleKey: "reports", permissionKey: "contract_report" },
    { path: routes.sessionHistoryReport, component: SessionHistoryReport  },
    { path: routes.scheduleComplianceReport, component: ScheduleComplianceReport  },
    { path: routes.timeRequestReport, component: TimeRequestReport  },
    { path: routes.leaveHistoryReport, component: LeaveHistoryReport  },
    { path: routes.timeEntryReport, component: TimeEntryReport  },
];

export default reportRoutes;